import { useApi } from './useApi';
import { useAppState } from './useAppState';
import { getHttpInstance, getApiConfig } from './useApi';
export function useInvestments() {
    const api = useApi();
    const state = useAppState();
    function getInvestmentInfo(onSuccess = null, refreshCache = false, clearCache = false) {
        const config = getApiConfig();
        const uri = config.api + (config.useCachedEndpoints ? '/Cached' : '') + "/Customers/00000000-0000-0000-0000-000000000000/InvestmentHubAccounts";
        if (clearCache) {
            localStorage.removeItem(uri);
            return;
        }
        api.GET(uri, (result) => {
            state.investmentInfo = result;
            if (onSuccess)
                onSuccess();
        }, !refreshCache, refreshCache);
    }
    function getInvestmentProviders(onSuccess = null) {
        api.GET("/InvestmentProviders", (result) => {
            state.investmentProviders = result;
            if (onSuccess)
                onSuccess(result);
        });
    }
    function getInvestmentTypes(onSuccess = null) {
        api.GET("/InvestmentTypes", (result) => {
            state.investmentTypes = result;
            if (onSuccess)
                onSuccess(result);
        }, true);
    }
    function getInvestmentAccount(id, onSuccess = null, refreshCache = false) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/InvestmentHubAccounts/" + id, (result) => {
            state.investmentAccount = result;
            if (onSuccess)
                onSuccess(result);
        }, !refreshCache, refreshCache);
    }
    function addInvestment(investment, onSuccess = null) {
        getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/InvestmentHubAccounts", investment)
            .then((response) => { if (onSuccess)
            onSuccess(response.data); })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => addInvestment(investment, onSuccess));
            }
        });
    }
    function updateInvestment(investment, onSuccess = null) {
        getHttpInstance().put(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/InvestmentHubAccounts/" + investment.id, investment)
            .then((response) => { if (onSuccess)
            onSuccess(response.data); })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => updateInvestment(investment, onSuccess));
            }
        });
    }
    function deleteInvestmentAccount(id, onSuccess = null) {
        getHttpInstance().delete(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/InvestmentHubAccounts/" + id)
            .then((response) => { if (onSuccess)
            onSuccess(response.data); });
    }
    return {
        getInvestmentInfo,
        getInvestmentProviders,
        getInvestmentTypes,
        getInvestmentAccount,
        addInvestment,
        updateInvestment,
        deleteInvestmentAccount,
    };
}
